import auth_manage from "./auth_manage";
import auth_admin from "./auth_admin";
import auth_member from "./auth_member"

export default [
  ...auth_manage,
  ...auth_admin,
  ...auth_member
];
